//Settings
import {
    MEGA_API,
    Sistema_ID,
    SERIAL_PADRAO
  } from "../modules/constants";
  
import mockedApi from "./mockStore"

export default ({ url = "", method = "GET", headers, data, params } = {}) => {

    switch (url) {
      case "/NewSession":
        return mockedNewSession();
      case "/BetList":
        return mockedListRequest();
      case "/BetListDetail":
        return mockedBetDetail(data.strTicket);
    }

  };

const mockedNewSession = () => {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockedApi.newSession);
        }, 0)
    });

}

const mockedListRequest = () => {

    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockedApi.listaDeApostasRetorno);
        }, 0)
    }
    );

};

const mockedBetDetail = (strTicket) => {

    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(mockedApi.detalheApostaRetorno[strTicket]);
        }, 0)
    }
    );

};




// WEBPACK FOOTER //
// ./src/mocking/mocked-request.js